

















import { Component, Vue } from "vue-property-decorator";
import { Carousel, Slide } from "vue-carousel";
import { IMerchant } from "@/store/interfaces/merchant";
import MerchantCard from "./MerchantCard.vue";
import { mapGetters } from "vuex";

@Component({
  name: "TopMerchantContainer",
  components: {
    Carousel,
    Slide,
    MerchantCard
  },
  computed: {
    ...mapGetters("home", ["getTopMerchants"])
  }
})
export default class TopMerchantContainer extends Vue {
  getTopMerchants: IMerchant[];
}
